<template>
  <div>
    <v-card style="display: contents">
      <div class="content-wrapper">
        <div
          style="
            font-size: 18px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            cursor: default;
            margin-top: -1rem;
          "
        ></div>
        <v-card-text>
          <div>
            <v-row
              cols="12"
              xs="12"
              sm="12"
              md="12"
              justify="center"
              class="mt-10"
            >
              <v-col
                cols="12"
                md="12"
                align="center"
                style="font-size: 22px; color: #14223c"
              >
                <p>{{ $t("message.ParkingRedemption") }}</p>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" md="12">
                <v-tabs>
                  <v-tab @click="ChangeTab('Search')">{{
                    $t("message.Search")
                  }}</v-tab>
                  <v-tab @click="ChangeTab('QR')">{{
                    $t("message.ScanQRCode")
                  }}</v-tab>
                  <!-- <v-tab @click="ChangeTab('Summary')"
                    >Redemption Summary</v-tab
                  > -->
                  <v-tabs-slider :color="ColorTab"></v-tabs-slider>
                  <v-tab-item>
                    <v-card flat class="responsive-margin">
                      <v-card-text>
                        <v-row cols="12" md="12" justify="center" class="mt-5">
                          <v-col cols="12" md="10">
                            <p class="TitleCSS">
                              {{ $t("message.PleaseInput") }}
                            </p>
                            <v-text-field
                              :placeholder="$t('message.InputPlaceholder')"
                              outlined
                              v-model="SearchInput"
                              @keyup.enter="SearchParking"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          justify="center"
                        >
                          <v-col cols="12" md="4" align="center">
                            <v-btn
                              height="40"
                              width="150"
                              outlined
                              color="indigo"
                              @click="SearchParking()"
                            >
                              {{ $t("message.Search") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-row justify="center">
                          <div>
                            <qrcode-stream
                              v-if="Status && scanning"
                              :constraints="qrConstraints"
                              :track="drawScanBox"
                              @decode="onDecode"
                              @init="onInit"
                            />
                          </div>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- <v-tab-item>
                    <v-card flat class="responsive-margin">
                      <v-card-text>
                        <v-row
                          cols="12"
                          md="12"
                          xs="12"
                          sm="12"
                          justify="center"
                          class="mt-5"
                        >
                          <v-col cols="12" md="6">
                            <v-data-table
                              :headers="headersSummary"
                              :items="RateList"
                              :items-per-page="5"
                              :mobile-breakpoint="0"
                              single-line
                              hide-details
                              :disable-sort="true"
                            >
                              <template v-slot:item="{ item }">
                                <tr>
                                  <td>{{ item.rateCode }}</td>
                                  <td>{{ item.rateDetail }}</td>
                                  <td>{{ item.limitQuotaRemain == null ? "ไม่จำกัด" : item.limitQuotaRemain }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item> -->
                </v-tabs>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="UpdateLicensePlateDialog" persistent width="400">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseUpdateLicensePlateDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <p style="font-size: 20px; color: black">กรุณาระบุทะเบียนรถ</p>
              <v-text-field
                placeholder="LicensePlate"
                label="License Plate"
                type="text"
                outlined
                v-model="LicensePlate"
                :maxlength="8"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <v-btn
                width="200"
                color="green"
                class="rounded-lg white--text"
                @click="updateLicensePlate()"
                x-large
                >Submit</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="UpdateLicensePlateDialogFromScan" persistent width="400">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseUpdateLicensePlateDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <p style="font-size: 20px; color: black">กรุณาระบุทะเบียนรถ</p>
              <v-text-field
                placeholder="LicensePlate"
                label="License Plate"
                type="text"
                outlined
                v-model="LicensePlate"
                :maxlength="8"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <v-btn
                width="200"
                color="green"
                class="rounded-lg white--text"
                @click="updateLicensePlateFromScan()"
                x-large
                >Submit</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>

    <AlertComponent
      :flagAlert="AlertDialog"
      :typeAlert="TypeAlert"
      :mesAlert="MessageAlert"
      @flagClose="ClearDataAlert()"
    />
  </div>
</template>
<script>
import axios from "axios";
// import { StreamBarcodeReader } from "vue-barcode-reader";
import enurl from "@/api/environment";
import AlertComponent from "@/components/Alert";
// import LoadingComponent from "@/components/Loading";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  name: "Main",
  components: {
    AlertComponent,
    // StreamBarcodeReader,
    // LoadingComponent,
    QrcodeStream,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      model: "tab-1",
      SearchInput: "",
      QRCodeData: "",
      id: null,
      destroy: false,
      Status: false,
      response: "",
      ColorTab: "#126496",
      ColorText: "#126496",
      ColorText2: "",
      UpdateLicensePlateDialog: false,
      UpdateLicensePlateDialogFromScan: false,
      LicensePlate: "",
      RateList: [],

      scanning: true,
      scanningLock: false,
      qrConstraints: {
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      },

      projectID: localStorage.getItem("ProjectSiteID"),
    };
  },
  computed: {
    headersSummary() {
      return [
        {
          text: "RateCode",
          align: "left",
        },
        {
          text: "Detail",
          align: "left",
        },
        {
          text: "Remaining",
          align: "left",
        },
      ];
    },
  },
  watch: {},

  methods: {
    drawScanBox(ctx, frame) {
      const { width, height } = frame;
      const size = Math.min(width, height) * 0.65;
      const x = (width - size) / 2;
      const y = (height - size) / 2;
      ctx.clearRect(0, 0, width, height);
      ctx.strokeStyle = "#00FF99";
      ctx.lineWidth = 4;
      ctx.strokeRect(x, y, size, size);
    },

    async onDecode(temp) {
      if (this.scanningLock) {
        return;
      }
      this.scanningLock = true;
      this.scanning = false;
      this.QRCodeData = temp;
      await this.SearchParkingByQRCode(temp);
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (e) {
        this.Status = false;
        this.scanning = false;
        this.scanningLock = false;

        Swal.fire({
          icon: "error",
          title: "Camera Error",
          width: 600,
          text: "ไม่สามารถเปิดกล้องได้ (เช็ค permission หรือ https)",
        });
      }
    },

    resumeScan() {
      this.scanning = true;
      this.scanningLock = false;
    },

    ChangeTab(value) {
      let self = this;
      if (value == "Search") {
        self.ColorTab = "#126496";
        self.ColorText = "#126496";
        self.Status = false;
      } else if (value == "QR") {
        self.ColorTab = "orange";
        self.Status = true;
        self.scanning = true;
        self.scanningLock = false;
      } else if (value == "Summary") {
        self.ColorTab = "#eb3636";
        self.ColorText = "#126496";
        self.Status = false;
      }
    },

    CloseTab() {
      window.close();
    },

    ClearDataAlert() {
      let self = this;
      self.AlertDialog = false;
      self.TypeAlert = "";
      self.MessageAlert = "";
    },

    async SearchParkingByQRCode(data) {
      let self = this;
      self.LoadingDialog = true;
      self.QRCodeData = data;
      let temp = {
        LogCarparkID: data,
        LostCard: false,
        projectID: self.projectID
      };
      await axios
        .post(`${self.url}Redemption/GetParkingDetailByQRCode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            if (response.data.data.length > 0) {
              var LicensePlate = response.data.data[0].plateNo.replace(" ", "");
              if (
                LicensePlate.includes("000") ||
                LicensePlate.includes("unknown")
              ) {
                self.UpdateLicensePlateDialogFromScan = true;
              } else {
                self.$router.push({
                  name: "ParkingInformation",
                  params: { response: self.response, LogID: self.LogCarparkID },
                });
              }
            }
          } else {
            Swal.fire({
              icon: "error",
              width: 900,
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
          self.resumeScan();
        });
    },

    CloseUpdateLicensePlateDialog() {
      this.LicensePlate = "";
      this.UpdateLicensePlateDialog = false;
      this.UpdateLicensePlateDialogFromScan = false;

      this.scanning = true;
      this.scanningLock = false;
    },

    updateLicensePlate() {
      let self = this;
      if (self.LicensePlate == "" || self.LicensePlate == null) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "กรุณากรอกเลขทะเบียน !",
        });
        return;
      }
      if (
        self.LicensePlate.includes("000") ||
        self.LicensePlate.includes("unknown")
      ) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "กรุณากรอกเลขทะเบียน !",
        });
        return;
      } else {
        var LastArrayData = "";
        if (self.QRCodeData != "") {
          var dataArray = self.QRCodeData.split("/");
          LastArrayData = dataArray[dataArray.length - 1];
        }

        let temp = {
          license: self.LicensePlate,
          logCarpark: self.SearchInput == "" ? LastArrayData : self.SearchInput,
          projectID: self.projectID
        };

        axios
          .post(`${self.url}Redemption/updateLicensePlate`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              var logCarpark =
                self.SearchInput == "" ? LastArrayData : self.SearchInput;
              self.CloseUpdateLicensePlateDialog();
              self.SearchParkingByQRCode(logCarpark);
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              width: 900,
              text: message,
            });
          });
      }
    },

    updateLicensePlateFromScan() {
      let self = this;
      if (self.LicensePlate == "" || self.LicensePlate == null) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "กรุณากรอกเลขทะเบียน !",
        });
        return;
      }
      if (
        self.LicensePlate.includes("000") ||
        self.LicensePlate.includes("unknown")
      ) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "กรุณากรอกเลขทะเบียน !",
        });
        return;
      } else {
        var dataArray = self.QRCodeData.split("/");
        var LastArrayData = dataArray[dataArray.length - 1];

        let temp = {
          license: self.LicensePlate,
          logCarpark: LastArrayData,
          projectID: self.projectID
        };
        axios
          .post(`${self.url}Redemption/updateLicensePlate`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.CloseUpdateLicensePlateDialog();
              self.SearchParkingByQRCode(LastArrayData);
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              width: 900,
              text: message,
            });
          });
      }
    },

    SearchParking() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.SearchInput,
        LostCard: false,
        projectID: self.projectID
      };
      axios
        .post(`${self.url}Redemption/GetParkingDetail`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            if (response.data.data.length > 0) {
              var LicensePlate = response.data.data[0].plateNo.replace(" ", "");
              if (
                LicensePlate.includes("000") ||
                LicensePlate.includes("unknown")
              ) {
                self.UpdateLicensePlateDialog = true;
              } else {
                self.$router.push({
                  name: "ParkingInformation",
                  params: { response: self.response, LogID: self.LogCarparkID },
                });
              }
            }
          } else {
            Swal.fire({
              icon: "warning",
              width: 900,
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    GetDataRateCodeSummary() {
      let self = this;
      axios
        .get(`${self.url}Redemption/GetDataRateCodeSummary`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data;
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        });
    },
  },
};
</script>
<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "English";
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.responsive-margin {
  margin-top: 0%;
}

@media (max-width: 600px) {
  .responsive-margin {
    margin-top: 10%;
  }
}
.content-wrapper {
  margin: 0 auto;
  max-width: 1100px;
}
.parking-card {
  display: block;
  background-color: #fff;
  padding: 0 1rem;
}

/* .qr-scan-wrapper {
  width: 100%;
  max-width: 360px;
  aspect-ratio: 1 / 1;
  margin: auto;
  position: relative;
}

.qr-scan-wrapper video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  border-radius: 12px;
} */
</style>
